import { memo, useEffect } from 'react';
import { Dimensions } from 'react-native';
import {
  Easing,
  useAnimatedStyle,
  useSharedValue,
  withRepeat,
  withSequence,
  withTiming,
} from 'react-native-reanimated';
import { useSelector } from '@betty/toolkit/state';
import { Box } from '@betty/moonlight';
import { selectCommunityJackpotEvents } from '../../../../../state';
import { FlareProps } from './Flare.types';
import CommunityJackpotImage from '../../../../CommunityJackpotImage/CommunityJackpotImage';

const { width: windowWidth, height: windowHeight } = Dimensions.get('window');

function Flare({ variant }: FlareProps) {
  const [event] = useSelector(selectCommunityJackpotEvents);
  const { milestoneReachedGlowUrl } = event;
  const scale = useSharedValue(2);
  const rotate = useSharedValue(0);
  const style = useAnimatedStyle(() => ({
    transform: [
      {
        scale: scale.value,
      },
      {
        rotate: `${rotate.value}deg`,
      },
    ],
  }));

  useEffect(() => {
    scale.value = withRepeat(
      withSequence(
        withTiming(2.0, { duration: 1200 }),
        withTiming(2.2, { duration: 1200 }),
        withTiming(2.0, { duration: 1200 }),
        withTiming(2.3, { duration: 1200 }),
        withTiming(2.0, { duration: 1200 }),
      ),
      -1,
    );
    rotate.value = withRepeat(
      withTiming(360, { duration: 6000, easing: Easing.linear }),
      -1,
    );
  }, [scale, rotate]);

  return (
    <Box
      position="absolute"
      pointerEvents="none"
      animatedStyle={style}
      opacity={0.6}
      zIndex={-1}
    >
      <CommunityJackpotImage
        url={milestoneReachedGlowUrl}
        fallback="communityJackpot.flare"
        width={Math.min(200, variant === 'small' ? 150 : windowWidth / 2)}
        height={Math.min(200, variant === 'small' ? 150 : windowHeight / 2)}
      />
    </Box>
  );
}

export default memo(Flare);
